import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase/client';
/**
 * Surveille l'état du WebSocket Realtime de Supabase.
 *
 * Subtilité importante : `supabase.realtime.isConnected()` retourne false
 * tant qu'AUCUN .subscribe() n'a été appelé — la WebSocket ne s'ouvre que
 * sur demande. Donc sur la home (pas de canal monté), isConnected()=false
 * mais ce n'est pas une "perte de connexion" : c'est un état nominal.
 *
 * On retourne donc 'idle' quand la liste des canaux est vide. Le banner
 * d'avertissement ne s'affiche que sur 'connecting' (canal demandé mais
 * socket pas prête).
 *
 * Polling 2s — léger et suffisant pour l'UX.
 */
export function useRealtimeStatus() {
    const [status, setStatus] = useState('idle');
    useEffect(() => {
        function check() {
            const rt = supabase.realtime;
            const channels = rt.channels ?? [];
            if (channels.length === 0) {
                setStatus('idle');
                return;
            }
            setStatus(rt.isConnected() ? 'connected' : 'connecting');
        }
        check();
        const id = window.setInterval(check, 2_000);
        return () => window.clearInterval(id);
    }, []);
    return status;
}
